<template>
  <a-modal
    :visible="visible"
    :title="$t('action.modifier')"
    @ok="updateCommand"
    @cancel="$emit('cancel')"
  >
    <div>
      <label for="state">{{ $t("command.state") }}:</label>
      <a-select
        v-model="selectedState"
        style="width: 100%"
        placeholder="Select state"
      >
        <a-select-option value="pending">{{
          $t("command.pending")
        }}</a-select-option>
        <a-select-option value="in progress">{{
          $t("command.inProgress")
        }}</a-select-option>
        <a-select-option value="validated">{{
          $t("command.validated")
        }}</a-select-option>
      </a-select>
    </div>
    <div style="margin-top: 16px">
      <label for="note">{{ $t("command.note") }}:</label>
      <a-textarea
        v-model="note"
        rows="4"
        placeholder="Enter note for the command"
      />
    </div>
  </a-modal>
</template>

<script>
import apiClient from "@/services/axios";

export default {
  name: "EditCommandModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    command: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedState: "",
      note: ""
    };
  },
  watch: {
    command: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal._id) {
          this.selectedState = newVal.state;
          this.note = "";
        }
      }
    }
  },
  methods: {
    updateCommand() {
      const payload = {};
      if (this.selectedState !== this.command.state)
        payload.state = this.selectedState;
      if (this.note.trim()) payload.note = this.note;
      
      if (!Object.keys(payload).length) {
        this.$message.info(this.$t("no.changes"));
        return;
      }
      
      apiClient
        .put(`/marketplace/command/${this.command._id}`, payload)
        .then(() => {
          this.$message.success(this.$t("success.commandUpdate"));
          this.$emit('updated');
        })
        .catch(() => {
          this.$message.error(this.$t("error.commandUpdate"));
        });
    }
  }
};
</script>